export default __webpack_public_path__ + "static/media/check-with-circle.58685aa1.svg";